import { IChuongTrinhDaoTaoRangBuocAddMultipleSysRequest } from "../../model/request/ctdt/IChuongTrinhDaoTaoRangBuocAddMultipleSysRequest";
import { apiClient } from "../apiClient";

const CHUONG_TRINH_DAO_TAO_RANGBUOC_ENDPOINT = "ctdt-rang-buoc";
export const chuongTrinhDaoTaoRangBuocApi = {
    SelectAll: () => apiClient.get(`${CHUONG_TRINH_DAO_TAO_RANGBUOC_ENDPOINT}`),
    InsertMultiple: (payload: IChuongTrinhDaoTaoRangBuocAddMultipleSysRequest) => apiClient.post(`${CHUONG_TRINH_DAO_TAO_RANGBUOC_ENDPOINT}/insert-multiple`, payload),
}